import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { loadCalendly } from "@/integrations/calendly";
import { track, initAnalytics } from "@/lib/analytics";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProblemSolution from "@/components/ProblemSolution";
import RevenueCalculator from "@/components/RevenueCalculator";
import ScorecardPromo from "@/components/ScorecardPromo";
import Benefits from "@/components/Benefits";
import LiveDemo from "@/components/LiveDemo";
import AuditPromo from "@/components/AuditPromo";
import Features from "@/components/Features";
import GrowthSystem from "@/components/GrowthSystem";
import UseCases from "@/components/UseCases";
import LeakageToClosed from "@/components/LeakageToClosed";
import ProofOfResults from "@/components/ProofOfResults";
import About from "@/components/About";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import LeadFlowAudit from "@/pages/LeadFlowAudit";
import Scorecard from "@/pages/Scorecard";
import AdminAudits from "@/pages/AdminAudits";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("page_view");
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Page not found</h1>
      <p className="mt-4 text-lg text-slate-300">The page you're looking for doesn't exist.</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center rounded-full px-8 py-4 bg-indigo-600 hover:bg-indigo-500 font-semibold text-white transition-colors duration-200"
      >
        Back to Home
      </Link>
    </div>
  );
}

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <RevenueCalculator />
        <ScorecardPromo />
        <Benefits />
        <LiveDemo />
        <AuditPromo />
        <Features />
        <GrowthSystem />
        <UseCases />
        <LeakageToClosed />
        <ProofOfResults />
        <About />
        <LeadForm />
      </main>
    </>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
    loadCalendly().catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-[#0B0F19] text-slate-50 antialiased">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/lead-flow-audit" element={<LeadFlowAudit />} />
          <Route path="/scorecard" element={<Scorecard />} />
          <Route path="/admin/audits" element={<AdminAudits />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}
